import { render, staticRenderFns } from "./mycontracts.vue?vue&type=template&id=8cf835d4&"
import script from "./mycontracts.vue?vue&type=script&lang=js&"
export * from "./mycontracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports